<script>
import {Auth} from 'aws-amplify';
import {unregisterFcmToken} from "@/plugins/firebase";
import apiEndpoints from "@/util/apiEndpoints";
import API from "@/shared/API";
import { mapState } from "vuex";
import UserTypes from "@/util/UserTypes";

export default {
  name: "Signout",
  computed: {
    ...mapState("RadStudies", ["studiesList"]),
    ...mapState(["currentUser"]),
    isRadiologist() {
      return this.currentUser && this.currentUser.type === UserTypes.radiology;
    },
  },
  methods: {
    clearLocalStorage() {
      try {
        localStorage.clear();
      } catch (e) {
        console.error("Failed to clear localStorage", e)
      }
    },
    clearCookies() {
      try {
        var cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i];
          var eqPos = cookie.indexOf("=");
          var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        }
      } catch (e) {
        console.error("Failed to clear cookies", e)
      }
    },
    clearSession() {
      try {
        sessionStorage.clear();
      } catch (e) {
        console.error("Failed to clear sessionStorage", e)
      }
    },
    clearIndexedDb() {
      try {
        const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;

        if (indexedDB) {
          window.indexedDB.databases().then((r) => {
            for (var i = 0; i < r.length; i++) window.indexedDB.deleteDatabase(r[i].name);
          })
        } else {
          console.log('IndexedDB not supported');
        }
      } catch (e) {
        console.error("Failed to clear indexedDB", e)
      }
    },
    clear() {
      console.log("start clearing ... ")
      this.clearIndexedDb();
      this.clearLocalStorage();
      this.clearCookies();
      this.clearSession();
    },
    async signOut() {
      try {
        if(this.isRadiologist){
          await this.releaseAllPickupStudies()
        }
        const role = localStorage.role;
        await unregisterFcmToken(role);
        try {
          const logoutUrl = `${apiEndpoints.logout}`;
          await API.get(logoutUrl).then(async () => {
            await Auth.signOut();
            this.clear();
          }).catch((error) => {
            console.log(error);
          });
        } catch (error) {
          console.log("Error while logout.");
        }
      } catch (error) {
        console.log('error signing out: ', error);
      }
    },
    releaseAllPickupStudies() {
      if (!this.studiesList || !Array.isArray(this.studiesList)) {
        console.error("studiesList is missing or not an array");
        return;
      }
      const studiesIds = this.studiesList
        .filter(item => item.pickup === true)
        .map(item => item.studyId);

      return API.post("/radiologist/withdrawAllPickedUpStudies", {
        studiesIds,
        logoutTrigger: "manual"
      });
    }
  },
  mounted() {
    this.signOut();
  }

};
</script>

<style scoped>

</style>